import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { BaseUrl } from "../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import { IoChatbubbles } from "react-icons/io5";
import { RiChatPrivateFill } from "react-icons/ri";
import { RiChatHistoryFill } from "react-icons/ri";
import {
  setExternalChatData,
  setChatSpinner,
  setInternalChatData,
  setSearchterm,
  setChatSessionId,
  setseletedVoiceSessionId,
  setAgentList,
  setcontactlist,
  closeNotify,
  setValue,
  setSelectedExternalChatType,
  GetAllUsers,
  updateContactList,
  updateAgentList,
  setShowEmailList,
  GetMissedChats,
  setCurrentTab,
  setTypedMessage,
} from "../../../Redux/Actions/actions";
import axios from "axios";
import { toast } from "react-toastify";
import { AppBar, Stack, Typography } from "@mui/material";
import Nointeractions2 from "../../../Assets/images/svg/No-interactions2.svg";

// Component
import ExternalContactList from "./Contact-list-child-component/External-ContactList.component";
import InternalAgentList from "./Contact-list-child-component/Internal-AgentList.component";
import { useDebounce } from "../../../Layout/Contacts/hooks";
import moment from "moment";
import { toaststyle } from "../../../Utils/toaststyle";
import MissedChat from "./Contact-list-child-component/MissedChat";
// style tab

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    chat: data.chat,
    value: data.value,
    agentList: data.agentList,
    selectedisvip: data.selectedisvip,
    searchterm: state.data.searchterm,
    internalExternal: data.internalExternal,
    contactList: contactListData.contactList,
    notification: state.notification.notification,
    internalChatData: contactListData.internalChatData,
    externalChatData: contactListData.externalChatData,
    missedChats: contactListData.missedChats,
  };
};

const Contactlist = (props) => {
  const debouncedSearch = useDebounce(props.searchterm);
  const agentId = JSON.parse(localStorage.getItem("tokenAgent"));
  const [loader, setloader] = useState(false);

  const updateCount = (value) => {
    const updatedContactList = [];
    JSON.parse(localStorage.getItem("contactList")).map((contact) => {
      if (contact.chat_session_id === value.chat_session_id) {
        contact.unreadcount = 0;
      }
      updatedContactList.push(contact);
    });

    props.updateContactList(updatedContactList);
    updateLastMes(value);
  };
  const updateLastMes = async (value) => {
    let data_to_pass = {
      id: value.id,
      lastMsg: value.lastmessage,
      time: moment().format("h:mm A"),
      count: 0,
    };

    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
        tenantId: localStorage.getItem("TenantId"),
      },
    };
    await axios
      .post(BaseUrl + "/message/updateLastMessage", data_to_pass, header)
      .then((res) => {})
      .catch((err) => {
        console.log("updateLastMes", err);
      });
  };
  const updateCount1 = (chat_session_id) => {
    const updatedAgentList = [];
    JSON.parse(localStorage.getItem("agentList")).map((contact) => {
      if (contact.chat_session_id === chat_session_id) {
        contact.unreadcount = contact.unreadcount = 0;
      }
      updatedAgentList.push(contact);
    });
    props.updateAgentList(updatedAgentList);
  };
  const getAllInternalAgents = async (val) => {
    setloader(true);
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + `/users/allInternalUsers?agent_id=${datas.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success == true) {
          localStorage.setItem("agentList", JSON.stringify(res.data.data));
          props.setAgentList(res.data.data);
          setloader(false);
          props.setChatSpinner(false);
        } else {
          localStorage.setItem("agentList", JSON.stringify([]));
          props.setAgentList([]);
          setloader(false);
          props.setChatSpinner(false);
        }
      })
      .catch((err) => {});
  };
  const SearchInternalAgent = async () => {
    setloader(true);
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        BaseUrl + `/users/allInternalUsersListBysearch?agent_id=${datas.id}`,
        {
          username: debouncedSearch,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          const newData = res.data.data;
          const currentState = props.agentList;
          const existingUsernames = new Set(
            currentState.map((item) => item.username)
          );
          const uniqueData = newData.filter(
            (item) => !existingUsernames.has(item.username)
          );
          props.setAgentList([...currentState, ...uniqueData]);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        } else {
          const currentState = props.agentList;
          props.setAgentList([...currentState]);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        }
      })
      .catch((err) => {});
  };
  const createInternalChat = async (UserId) => {
    const getAgent = await JSON.parse(localStorage.getItem("tokenAgent"));
    await axios
      .post(
        `${BaseUrl}/users/createInternalAgentsSession`,
        {
          userId: UserId,
          agentId: getAgent.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message, toaststyle);
          props.setSearchterm("");
        } else {
          toast.error(res.data.message, toaststyle);
          props.setSearchterm("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const externalChat = (contact) => {
    if (!contact) return;
    localStorage.setItem("client", JSON.stringify(contact));
    if (contact.channel != "email" || contact.channel != "voice") {
      if (contact.unreadcount != 0) {
        updateCount(contact);
      }
      props.setChatSessionId(contact.chat_session_id);
    }
    props.setCurrentTab("customerDetails");
    props.setExternalChatData(contact);
    props.setSelectedExternalChatType(contact.channel);
    props.closeNotify(contact.id, props.notification);
    props.setseletedVoiceSessionId(contact.chat_session_id);
    props.setTypedMessage(contact.draftMessage);
  };
  const internalChat = (val) => {
    if (!val) return;
    if (val.unreadcount != 0) {
      updateCount1(val.chat_session_id);
    }
    if (!val.chat_session_id) {
      createInternalChat(val.user_id);
      return;
    }
    localStorage.setItem("client", JSON.stringify(val));
    props.setChatSessionId(val.chat_session_id);
    props.setInternalChatData(val);
    props.closeNotify(val.id, props.notification);
  };
  const missedChat = (contact) => {
    if (!contact) return;
    localStorage.setItem("client", JSON.stringify(contact));
    props.setCurrentTab("MissedChat");
    props.setExternalChatData(contact);
    props.setSelectedExternalChatType(contact.channel);
    props.closeNotify(contact.id, props.notification);
  };
  const handleChange = (event, newValue) => {
    props.setValue(newValue);
  };
  useEffect(() => {
    props.GetAllUsers();
  }, []);
  useEffect(() => {
    if (debouncedSearch === "") return;
    if (debouncedSearch.length >= 4) {
      SearchInternalAgent();
    } else if (debouncedSearch < 3) {
      getAllInternalAgents();
    }
  }, [debouncedSearch]);

  return (
    <Box
      onContextMenu={(event) => {
        event.preventDefault();
      }}
      sx={{
        height: "100%",
        minWidth: "14rem",
        maxWidth: "14rem",
        width: "14rem",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        borderRadius: "7px 0 0px 7px",
        background: "white",
        boxShadow: "#cfd1d6e8 -8px 2px 0px, #c8c8c86b 0px 1px 5px",
      }}
    >
      <Box
        sx={{
          height: "72px",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          width: "14rem",
          borderRadius: "7px 0 0 0",
          background: "white",
        }}
        className="p-2 px-0 pb-0"
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: "15px",
            fontWeight: "600",
            color: "#0b3363",
          }}
          gutterBottom
          className="border-bottom px-2"
        >
          Interactions
        </Typography>
        <Box sx={{ background: "#F3F7EC", width: "100%" }}>
          <AppBar
            position="static"
            sx={{
              background: "white",
              boxShadow: "none",
              height: "auto",
            }}
          >
            <Tabs
              value={props.value}
              onChange={handleChange}
              centered
              variant="fullWidth"
              className="MuiTabs-sizeSm"
              sx={{
                minHeight: "34px",
                ".&MuiTabs-scrollButton": {
                  width: "17px",
                },
              }}
            >
              {JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "ACTIVE_INTERACTION" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tab
                        size="small"
                        key={0}
                        id="pills-tabs"
                        icon={<IoChatbubbles />}
                        iconPosition="start"
                        label={"Active"}
                        onClick={() => {
                          props.GetAllUsers();
                          props.setExternalChatData("");
                          props.setInternalChatData("");
                          props.setChatSessionId("");
                          localStorage.removeItem("client");
                        }}
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                      />
                    );
                  } else {
                    return (
                      <Tab
                        size="small"
                        key={0}
                        id="pills-tabs"
                        icon={<IoChatbubbles />}
                        iconPosition="start"
                        label={"Active"}
                        disabled
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                      />
                    );
                  }
                }
              })}

              {JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "INTERNAL_INTERACTION" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tab
                        key={1}
                        id="pills-tabs"
                        icon={<RiChatPrivateFill />}
                        iconPosition="start"
                        label={"Internal"}
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          getAllInternalAgents();
                          props.setInternalChatData("");
                          props.setExternalChatData("");
                          props.setChatSessionId("");
                          localStorage.removeItem("client");
                          props.setSearchterm("");
                        }}
                      />
                    );
                  } else {
                    return (
                      <Tab
                        key={1}
                        id="pills-tabs"
                        icon={<RiChatPrivateFill />}
                        iconPosition="start"
                        label={"Internal"}
                        disabled
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                      />
                    );
                  }
                }
              })}

              {JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "PURPLE_ABANDONED_INTERACTION" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tab
                        key={2}
                        id="pills-tabs"
                        icon={<RiChatHistoryFill />}
                        iconPosition="start"
                        label={"Missed"}
                        onClick={() => {
                          props.GetMissedChats();
                        }}
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                      />
                    );
                  } else {
                    return (
                      <Tab
                        key={2}
                        id="pills-tabs"
                        icon={<RiChatHistoryFill />}
                        iconPosition="start"
                        label={"Missed"}
                        disabled
                        sx={{
                          fontSize: "13px",
                          color: "#0b3363",
                          textTransform: "capitalize",
                          minWidth: "75px",
                          minHeight: "20px",
                          padding: " 5px",
                          fontSize: "12px",
                        }}
                      />
                    );
                  }
                }
              })}
            </Tabs>
          </AppBar>
        </Box>
      </Box>

      <Box
        className="chat-users"
        sx={{
          height: "calc(100% - 88px)",
          overflow: "hidden",
          overflowY: "auto",
          padding: "6px",
        }}
      >
        {(() => {
          switch (props.value) {
            case 0:
              return (
                <>
                  {props.contactList.length > 0 ? (
                    props.contactList.map((contact, index) =>
                      contact != undefined ? (
                        <ExternalContactList
                          key={index}
                          externalChat={externalChat}
                          contact={contact}
                          index={index}
                        />
                      ) : null
                    )
                  ) : (
                    <div className="text-muted d-flex justify-content-center h-100 flex-column">
                      <span className="mx-auto">
                        <img
                          src={Nointeractions2}
                          alt="pic"
                          style={{ width: "11rem", userSelect: "none" }}
                        />
                      </span>
                      <span className="mx-auto">
                        <h6
                          className="text-muted mt-2"
                          style={{ fontSize: "13px" }}
                        >
                          No active interactions
                        </h6>
                      </span>
                    </div>
                  )}
                </>
              );
            case 1:
              return (
                <Stack sx={{ height: "100%", width: "100%" }}>
                  <div className="chat-search rounded position-relative w-100 mb-2">
                    <input
                      className="form-control color_b"
                      type="search"
                      style={{
                        height: "35px",
                        borderRadius: "7px",
                      }}
                      value={props.searchterm}
                      placeholder="Search Agent"
                      aria-label="Search Agent"
                      onChange={(e) => {
                        props.setSearchterm(e.target.value);
                      }}
                    />
                  </div>

                  {props.agentList.length > 0 ? (
                    props.agentList
                      .filter((val) => {
                        if (props.searchterm == "") {
                          return val;
                        } else if (val.reciverDetails) {
                          var result = val.reciverDetails[0].username
                            .toLowerCase()
                            .includes(props.searchterm.toLowerCase());
                          if (
                            result === true &&
                            agentId.id !== val.reciverDetails[0]._id
                          ) {
                            return val;
                          } else {
                            var result = val.senderDetails[0].username
                              .toLowerCase()
                              .includes(props.searchterm.toLowerCase());
                            if (
                              result === true &&
                              agentId.id !== val.senderDetails[0]._id
                            ) {
                              return val;
                            }
                          }
                        } else if (
                          val.username
                            .toLowerCase()
                            .includes(props.searchterm.toLowerCase())
                        ) {
                          return val;
                        }
                      })
                      .map((val, index) => {
                        return (
                          <InternalAgentList
                            key={index}
                            index={index}
                            val={val}
                            internalChat={internalChat}
                            createInternalChat={createInternalChat}
                            loader={loader}
                          />
                        );
                      })
                  ) : (
                    <div className="text-muted d-flex justify-content-center h-100 flex-column">
                      <span className="mx-auto">
                        <img
                          src={Nointeractions2}
                          alt="pic"
                          style={{ width: "11rem", userSelect: "none" }}
                        />
                      </span>
                      <span className="mx-auto">
                        <h6
                          className="text-muted mt-2"
                          style={{ fontSize: "13px" }}
                        >
                          No active interactions
                        </h6>
                      </span>
                    </div>
                  )}
                </Stack>
              );
            case 2:
              return (
                <>
                  {props.missedChats.length > 0 ? (
                    props.missedChats.map((contact, index) => (
                      <MissedChat
                        key={index}
                        contact={contact}
                        index={index}
                        missedChat={missedChat}
                      />
                    ))
                  ) : (
                    <div className="text-muted d-flex justify-content-center h-100 flex-column">
                      <span className="mx-auto">
                        <img
                          src={Nointeractions2}
                          alt="pic"
                          style={{ width: "11rem", userSelect: "none" }}
                        />
                      </span>
                      <span className="mx-auto">
                        <h6
                          className="text-muted mt-2"
                          style={{ fontSize: "13px" }}
                        >
                          No active interactions
                        </h6>
                      </span>
                    </div>
                  )}
                </>
              );
            default:
              return null;
          }
        })()}
      </Box>
    </Box>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  setChatSpinner,
  setInternalChatData,
  setSearchterm,
  setChatSessionId,
  setseletedVoiceSessionId,
  setAgentList,
  setcontactlist,
  closeNotify,
  setValue,
  setSelectedExternalChatType,
  GetAllUsers,
  updateContactList,
  updateAgentList,
  setShowEmailList,
  GetMissedChats,
  setCurrentTab,
  setTypedMessage,
})(Contactlist);
